import { Constant, UserScheme } from "client-v2";
import styled from "styled-components";
import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { useEffect, useState } from "react";
import media from "styled-media-query";
import HobbiesStamp from "../../../components/stamp/HobbiesStamp";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import dayjs from "dayjs";

const screen03: any = "950px";
const Container = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin: 0px 0px 0px 42px;
	width: 408px;
	max-height: calc(var(--doc-height) - 72px - 16px);
	overflow: scroll;
	-ms-overflow-style: none;
	scrollbar-width: none;
	::-webkit-scrollbar {
		display: none;
	}
	${media.lessThan(screen03)`
        display: none;
    `}
`;
const GrandpaContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: white;
	margin-top: 24px;
	border-radius: 24px;
	padding: 24px 24px 32px;
`;
const GrandpaImage = styled.img`
	width: 120px;
	height: 120px;
	object-fit: cover;
	border-radius: 16px;
`;
const GrandpaDataContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	gap: 32px;
`;
const GrandpaData = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;
const HobbiesContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`;
const Col = styled.div`
	display: flex;
	flex-direction: column;
`;

const LetterRight = (props: LetterRightProps) => {
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const appLocation = useSelector((state: State) => state.location.location);
	const [hobbies, setHobbies] = useState<any[]>([]);

	useEffect(() => {
		if (props.grandpa && props.grandpa.data && props.grandpa.data.hobbies) {
			const hobbiesConstants = Constant.hobbies();
			const temp = props.grandpa.data.hobbies
				.map((item) => {
					const result = hobbiesConstants.filter(
						(i) => i.id === item
					);
					if (result.length > 0) {
						return {
							title:
								appLocation?.language === "en"
									? result[0].label_en
									: result[0].label,
							icon: result[0].icon,
							backgroundColor: result[0].backgroundColor,
						};
					}
				})
				.filter((i) => i)
				.slice(0, 5);
			setHobbies(temp);
		}
	}, [props.grandpa]);
	return (
		<Container>
			<Text type="h3" weight="semibold" style={{ marginBottom: 16 }}>
				Escribe tu carta
			</Text>
			<Text type="p">
				Te dejamos algunos datos de la persona mayor a la que vas a
				escribir para que te sea más sencillo conectar y redactar tu
				carta.
			</Text>
			<GrandpaContainer>
				<GrandpaDataContainer>
					<GrandpaData>
						<Text
							type="p"
							style={{
								fontFamily: "DM Mono",
								letterSpacing: 2,
								fontSize: 14,
								color: ColorV2.text.neutralMedium,
								marginBottom: 12,
							}}
						>
							DESTINATARIO
						</Text>
						<Text
							type="h5"
							weight="semibold"
							style={{ marginBottom: 8 }}
						>
							{props.grandpa.name}
						</Text>
						{props.grandpa.birthday && (
							<Text type="p2">
								{dayjs().diff(
									props.grandpa.birthday?.iso,
									"years"
								)}
								{translation.years}
							</Text>
						)}
						<Text type="p2">{props.grandpa.shortAddress}</Text>
					</GrandpaData>
					<Col style={{ width: 120 }}>
						<GrandpaImage
							src={
								props.grandpa.image
									? props.grandpa.image.url
									: props.grandpa.gender
									? props.grandpa.gender === "male"
										? require("../../../assets/images/icon/grandpa_icon.png")
										: props.grandpa.gender === "female"
										? require("../../../assets/images/icon/grandma_icon.png")
										: require("../../../assets/images/icon/user_icon.png")
									: require("../../../assets/images/icon/user_icon.png")
							}
						/>
						<Text
							type="c2"
							style={{
								fontSize: 10,
								color: ColorV2.text.neutralMedium,
								marginTop: 4,
							}}
						>
							No compartas su foto en redes, por favor
						</Text>
					</Col>
				</GrandpaDataContainer>
				<Text
					type="p2"
					weight="medium"
					style={{ margin: "8px 0px 16px" }}
				>
					Sus aficiones son
				</Text>
				<HobbiesContainer>
					{hobbies.map((hobby, index) => (
						<HobbiesStamp
							key={"hobby_" + index}
							icon={hobby.icon}
							title={hobby.title}
							backgroundColor={hobby.backgroundColor}
						/>
					))}
				</HobbiesContainer>
			</GrandpaContainer>
		</Container>
	);
};
export default LetterRight;
export interface LetterRightProps {
	grandpa: UserScheme;
}
